/** Error de GoTrue: `{ code, error_code, msg }`. */
interface GoTrueErrorBody {
  error_code?: string;
  msg?: string;
  message?: string;
}

const MESSAGES: Record<string, string> = {
  otp_expired: 'El código no es válido o ha caducado. Pide uno nuevo.',
  over_email_send_rate_limit:
    'Has pedido demasiados códigos. Espera un momento antes de volver a intentarlo.',
  over_request_rate_limit:
    'Demasiados intentos. Espera un momento antes de volver a intentarlo.',
  email_address_invalid: 'Introduce un email válido.',
  validation_failed: 'Introduce un email válido.',
  signup_disabled: 'El registro de cuentas nuevas está desactivado.',
};

/** Traduce la respuesta de error de GoTrue a un mensaje para el usuario. */
export async function authErrorMessage(response: Response, fallback: string): Promise<string> {
  const body = (await response.json().catch(() => null)) as GoTrueErrorBody | null;
  if (body?.error_code && MESSAGES[body.error_code]) return MESSAGES[body.error_code];
  if (response.status === 429) return MESSAGES.over_request_rate_limit;
  return body?.msg ?? body?.message ?? fallback;
}
